import { motion } from "framer-motion";

function AnimarAlScroll({ children, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 55, scale: 0.96 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ delay, type: "spring", stiffness: 120, damping: 14, mass: 0.7 }}
    >
      {children}
    </motion.div>
  );
}

export default AnimarAlScroll;